"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"

const SideMenu = ({ faqs }: { faqs: { slug: string; title: string }[] }) => {
  const path = usePathname()

  return (
    <div className="sticky top-[250px] hidden w-1/4 min-w-[250px] flex-col items-start gap-y-4 sm:flex md:ml-5">
      {faqs.map((faq, index) => (
        <Link
          title={faq.title}
          key={index}
          href={`/faqs/${faq.slug}`}
          className={` ${path?.endsWith(faq.slug) ? "text-fg-inverse" : "text-[#FFFFFF59]"}`}>
          {faq.title}
        </Link>
      ))}
    </div>
  )
}

export default SideMenu
